<div class="main-padding">
  <h3 class="header-bottom header-text1">{{ 'UNPAID_LIST.TITLE' | translate }}</h3>
  <div class="text-center">
    <div class="finish text-center">
      {{ 'UNPAID_USER_APPLY.THE_APPLICATION_IS_COMPLETE' | translate }}
    </div>
    <div class="text-center">
      <div class="col-12">
        <div class="display finish2">
          <a (click)="back()" class="btn-grey">
            {{ 'UNPAID_USER_APPLY.RETURN_TO_UNPAID_MEMBER_LIST' | translate }}
          </a>
        </div>
      </div>
    </div>
  </div>     
</div>